import { RemoteCityAdapterConfig } from "../../../../data/usecases/city-adapter-config/remote-city-adapter-config";
import { CityAdapterConfigAdmin } from "../../../../domain/models/city-adapter-config";
import { makeAxiosHttpClient } from "../../http/axios-http-client-factory";

export const makeRemoteCityAdapterConfig = (): CityAdapterConfigAdmin =>
  new RemoteCityAdapterConfig("/admin/city-adapter-config", makeAxiosHttpClient());
